export var TypeActionAnimations;
(function (TypeActionAnimations) {
    TypeActionAnimations["AddPellets"] = "Animation > AddPellets";
    TypeActionAnimations["AddPelletsInScreenCenter"] = "Animation > AddPelletsInScreenCenter";
    TypeActionAnimations["AddPelletsOnContractFulfill"] = "Animation > AddPelletsOnContractFulfill";
    TypeActionAnimations["RemovePellets"] = "Animation > RemovePellets";
})(TypeActionAnimations || (TypeActionAnimations = {}));
export var actionAddPelletsAnimations = function (id, rewards, origin) { return ({
    id: id,
    origin: origin,
    rewards: rewards,
    type: TypeActionAnimations.AddPellets,
}); };
export var actionRemoveRewardPelletsAnimation = function (id) { return ({
    id: id,
    type: TypeActionAnimations.RemovePellets,
}); };
export var actionAddPelletsInScreenCenterAnimation = function (id, rewards) { return ({
    id: id,
    rewards: rewards,
    type: TypeActionAnimations.AddPelletsInScreenCenter,
}); };
export var actionAddPelletsOnContractFulfillAnimation = function (contractRewardInfo) { return ({
    contractRewardInfo: contractRewardInfo,
    type: TypeActionAnimations.AddPelletsOnContractFulfill,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/actionPelletAnimations.ts
// module id = 73
// module chunks = 3